import type * as Icons from "@mui/icons-material";

export const DRAWER_WIDTH = 240;

export interface NavItem {
  path: string;
  labelKey: string;
  icon: keyof typeof Icons;
}

export const NAV_ITEMS: NavItem[] = [
  { path: "/", labelKey: "nav.home", icon: "Home" },
  { path: "/companies", labelKey: "nav.companies", icon: "Business" },
];

export const AUTH_NAV_ITEMS: NavItem[] = [
  { path: "/reviews", labelKey: "nav.reviews", icon: "RateReview" },
  { path: "/account", labelKey: "nav.account", icon: "AccountCircle" },
];
